export default __webpack_public_path__ + "static/media/website.3d9f6e26.svg";